import {
  Component,
  Input,
  Output,
  EventEmitter,
  forwardRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-input-text',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppInputTextComponent),
      multi: true,
    },
  ],
  template: `
    <input
      pInputText
      [type]="type"
      [placeholder]="placeholder"
      [attr.maxlength]="maxlength || null"
      [attr.min]="min ?? null"
      [attr.max]="max ?? null"
      [disabled]="disabled"
      [readonly]="readonly"
      [value]="value"
      (input)="onInput($event)"
      (blur)="onBlur()"
      (keypress)="keypress.emit($event)"
      (keyup.enter)="enterPress.emit($event)"
      (paste)="paste.emit($event)"
    />
  `,
  styleUrls: ['./app-input-text.component.scss'],
})
export class AppInputTextComponent implements ControlValueAccessor {
  @Input() placeholder: string = '';
  @Input() type: string = 'text';
  @Input() maxlength: number | null = null;
  @Input() min: number | null = null;
  @Input() max: number | null = null;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;

  @Output() keypress = new EventEmitter<KeyboardEvent>();
  @Output() enterPress = new EventEmitter<KeyboardEvent>();
  @Output() paste = new EventEmitter<ClipboardEvent>();

  value: string = '';

  private _onChange: (v: string) => void = () => {};
  private _onTouched: () => void = () => {};

  onInput(event: Event): void {
    const val = (event.target as HTMLInputElement).value;
    this.value = val;
    this._onChange(val);
  }

  onBlur(): void {
    this._onTouched();
  }

  writeValue(val: string): void {
    this.value = val ?? '';
  }

  registerOnChange(fn: (v: string) => void): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this._onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
